import { Card as e } from "../components/Card/Card.mjs";
import { Typography as t } from "../Typography/Typography.mjs";
import "react";
import { styled as n } from "styled-components";
import { useTranslation as r } from "@maat/store-i18n";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/Auth/RoleSelector.tsx
var o = () => {
	let { t: e } = r("ds");
	return [{
		id: "Guest",
		title: e("ds:roleSelector.guest.title"),
		description: e("ds:roleSelector.guest.description"),
		icon: "🏠"
	}, {
		id: "Host",
		title: e("ds:roleSelector.host.title"),
		description: e("ds:roleSelector.host.description"),
		icon: "🔑"
	}];
}, s = n.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(2)};
    width: 100%;
`, c = n(e)`
    cursor: pointer;
    border: 2px solid
        ${({ theme: e, $selected: t }) => t ? e.colors.primary : e.colors.border} !important;
    background-color: ${({ theme: e, $selected: t }) => t ? `${e.colors.primary}0f` : e.colors.card};
    transition: all ${({ theme: e }) => e.transitions.fast};

    &:hover {
        border-color: ${({ theme: e }) => e.colors.primary} !important;
    }
`, l = n.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(2)};
`, u = n.div`
    font-size: 2rem;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme: e }) => e.colors.muted};
    border-radius: ${({ theme: e }) => e.radii.md};
`, d = n.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(1)};
`, f = n.div`
    width: 22px;
    height: 22px;
    border-radius: ${({ theme: e }) => e.radii.full};
    border: 2px solid
        ${({ theme: e, $visible: t }) => t ? e.colors.primary : e.colors.border};
    background-color: ${({ theme: e, $visible: t }) => t ? e.colors.primary : "transparent"};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all ${({ theme: e }) => e.transitions.fast};
    color: ${({ theme: e }) => e.colors.primaryForeground};
    font-size: 12px;
`, p = ({ selectedRole: e, onChange: n, className: r }) => /* @__PURE__ */ i(s, {
	className: r,
	children: o().map((r) => {
		let o = e === r.id;
		return /* @__PURE__ */ i(c, {
			padding: "medium",
			elevation: "none",
			$selected: o,
			onClick: () => n(r.id),
			children: /* @__PURE__ */ a(l, { children: [
				/* @__PURE__ */ i(u, { children: r.icon }),
				/* @__PURE__ */ a(d, { children: [/* @__PURE__ */ i(t, {
					variant: "h4",
					weight: "bold",
					children: r.title
				}), /* @__PURE__ */ i(t, {
					variant: "small",
					color: "secondary",
					children: r.description
				})] }),
				/* @__PURE__ */ i(f, {
					$visible: o,
					children: o && "✓"
				})
			] })
		}, r.id);
	})
});
//#endregion
export { p as RoleSelector };
